import { render, staticRenderFns } from "./ProjetBlocFore.vue?vue&type=template&id=49ed944d&scoped=true&lang=true&"
import script from "./ProjetBlocFore.vue?vue&type=script&lang=js&"
export * from "./ProjetBlocFore.vue?vue&type=script&lang=js&"
import style0 from "./ProjetBlocFore.vue?vue&type=style&index=0&id=49ed944d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed944d",
  null
  
)

export default component.exports